import { useState, useCallback } from "react";
import * as Constants from "../components/Constants.js";

const useGetListaURL = () => {
  const [isCargando, setCargando] = useState(false);
  const [erroresGetLista, setErroresGetLista] = useState(null);

  const fetchData = useCallback(async (path, usarDatos) => {
    setCargando(true);
    setErroresGetLista(null);

    try {
      const response = await fetch(Constants.URLBASE + "/" + path, {
        method: "GET",
        redirect: "follow",
        credentials: "include",
      });

      if (response.status === 401) {
        document.location.href = "/nosession";
      } else if (response.redirected) {
        document.location = response.url;
      } else if (!response.ok) {
        throw new Error(response.status + " - " + response.error);
      }

      if (response.status === 204) {
        usarDatos([]);
      } else {
        const env = await response.json();
        if (env && (env.ok === true || env.ok === false || 'data' in env || 'errors' in env || 'errores' in env)) {
          if (env.ok) {
            usarDatos(env.data ?? []);
          } else {
            setErroresGetLista(env.errors ?? env.errores ?? ["Error al cargar la lista"]);
            usarDatos([]);
          }
        } else {
          usarDatos(env);
        }
      }
    } catch (err) {
      console.error("Error GetLista", err.message);
      setErroresGetLista(["Error al cargar la lista"]);
      usarDatos([]);
    }
    setCargando(false);
  }, []);

  const resetErroresGetLista = useCallback(() => {
    setErroresGetLista(null);
  }, []);

  return { isCargando, erroresGetLista, fetchData, resetErroresGetLista };
};

export default useGetListaURL;
